import React from 'react';
import { Avatar as MuiAvatar } from '@mui/material';

/**
 * Tab Đánh Giá Ứng Viên (`evaluations`)
 * Quản lý phiếu đánh giá, chấm điểm phỏng vấn và nhận xét từ người phỏng vấn.
 */
export const RecruiterEvaluationsTab: React.FC = () => {
  return (
    <div className="space-y-6 animate-fade-in text-left">
      <div className="border-b pb-5">
        <h1 className="font-display font-bold text-2xl text-gray-900 leading-tight">Đánh giá ứng viên</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {[
          {
            candidate: 'Lê Quỳnh Chi',
            position: 'HR Executive',
            interviewer: 'Nguyễn Văn A',
            rating: 4,
            notes: 'Kỹ năng chuyên môn nghiệp vụ nhân sự rất tốt. Đã từng tuyển dụng chuỗi nhà hàng lớn. Giao tiếp mạch lạc tự tin.',
            status: 'Khuyên tuyển',
            avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
          },
          {
            candidate: 'Nguyễn Hoàng Nam',
            position: 'Frontend Developer',
            interviewer: 'Trần Văn B (Tech Lead)',
            rating: 5,
            notes: 'Năng lực ReactJS/Tailwind tuyệt vời. Khả năng tư duy logic tốt. Trả lời xuất sắc các câu hỏi thuật toán hệ thống.',
            status: 'Tuyển gấp',
            avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
          },
        ].map((evalItem, i) => (
          <div key={i} className="bg-white rounded-3xl p-6 border border-gray-100 shadow-sm space-y-4 hover:shadow-md transition-shadow">
            <div className="flex items-center gap-3.5">
              <MuiAvatar src={evalItem.avatar} sx={{ width: 44, height: 44, borderRadius: '12px' }} />
              <div>
                <h4 className="font-bold text-gray-800">{evalItem.candidate}</h4>
                <span className="text-xs text-gray-400 font-bold block mt-0.5">{evalItem.position}</span>
              </div>
            </div>

            <div className="border-t pt-3.5 space-y-2 text-xs font-semibold">
              <div className="flex justify-between">
                <span className="text-gray-400">Người đánh giá:</span>
                <span className="text-gray-700">{evalItem.interviewer}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-400">Điểm đánh giá:</span>
                <div className="text-[#ff9d00] flex gap-0.5 text-sm">
                  {Array.from({ length: 5 }).map((_, rIdx) => (
                    <span key={rIdx}>{rIdx < evalItem.rating ? '★' : '☆'}</span>
                  ))}
                </div>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-400">Đề xuất:</span>
                <span className="text-green-600 font-bold bg-green-50 px-2.5 py-0.5 rounded-full">{evalItem.status}</span>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100 text-xs text-gray-600 leading-relaxed italic">
              " {evalItem.notes} "
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecruiterEvaluationsTab;
